module.exports = __webpack_public_path__ + "static/media/The Future Is Now.5d97286b.jpg";